<ngb-toast
  *ngFor="let toast of toastService.toasts"
  [class]="toast.type"
  [header]="toast.header"
  [autohide]="true"
  [delay]="toast.delay || 5000"
  (hiddden)="toastService.remove(toast)"
  >{{ toast.body }}</ngb-toast
>
